module.exports = __webpack_public_path__ + "static/img/jiceng2.4c963a5a.png";